
.group {
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.root {
	width: var(--checkbox-size);
	height: var(--checkbox-size);
	margin: 0;
	border: var(--checkbox-border-width) solid var(--checkbox-border-color);
	border-radius: 100%;
	color: var(--checkbox-tick-color); /* drives the inner dot via currentcolor */

	/* reset the <span> defaults Base UI renders */
	display: inline-block;
	box-sizing: border-box;
	position: relative; /* anchor for the ::after inner dot */
	vertical-align: text-bottom;
	cursor: pointer;
	outline: none;

	transition: border-color 0.15s ease-in-out,
	box-shadow 0.15s ease-in-out,
	color 0.15s ease-in-out;
}

.root:hover:not(:disabled):not([data-disabled]) {
	border-color: var(--color-primary-hover);
	color: var(--color-primary-hover);
}

.root:focus-visible {
	border-color: var(--color-primary);
	box-shadow: 0 0 0 3px var(--color-primary-focus-ring);
}

.root:disabled,
.root[data-disabled] {
	opacity: 0.5;
	cursor: not-allowed;
}


.indicator {
	display: block;
	width: 100%;
	height: 100%;
	position: relative;
}

.indicator::after {
	content: "";
	/* mirrors nativeRadio.less: @native-radio-size - 10 */
	width: calc(var(--checkbox-size) - 10px);
	height: calc(var(--checkbox-size) - 10px);
	background-color: currentcolor;
	border-radius: 100%;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%) scale(0);
	opacity: 0;
	transition: transform 0.15s ease-in-out,
	opacity 0.15s ease-in-out;
}

.indicator[data-checked]::after {
	transform: translate(-50%, -50%) scale(1);
	opacity: 1;
}
